export const PAGE_DASHBOARD = 'dashboard';
export const PAGE_SETTINGS = 'settings';
export const PAGE_SUMMARY = 'summary';
export const PAGE_THANK_YOU = 'thank-you';
export const STATUS_INACTIVE = 'inactive';
export const STATUS_ACTIVE = 'active';
export const STATUS_IN_PROGRESS = 'in-progress';
export const MEMBER_CONFIG_SUCCESS_MESSAGE_ADD = 'member-success-add';
export const MEMBER_CONFIG_SUCCESS_MESSAGE_REMOVE = 'member-success-remove';
export const MEMBER_CONFIG_SUCCESS_MESSAGE_CHANGE = 'member-success-change';
export const PACKAGE_SELECT_VARIANT_DATA_SHARING_A = 'package-select-variant-data-sharing-a';
export const PACKAGE_SELECT_VARIANT_DATA_SHARING_B = 'package-select-variant-data-sharing-b';
export const PACKAGE_SELECT_VARIANT_DATA_MERGE = 'package-select-variant-data-merge';
export const PACKAGE_SELECT_VARIANT_DATA_MERGE_FOUNDER =
  'package-select-variant-data-merge-founder';

export const M_HUB_CATEGORY_ID = 'Mobile Data.MMM Voice SIM';
export const M_HUB_PAGE_VIEW_DASHBOARD = 'mhub-pv-dashboard';
export const M_HUB_PAGE_VIEW_SETTINGS = 'mhub-pv-settings';
export const M_HUB_PAGE_VIEW_ACTIVATION = 'mhub-pv-activation';
export const M_HUB_PAGE_VIEW_DEACTIVATION = 'mhub-pv-deactivation';
export const M_HUB_PAGE_VIEW_CHANGE = 'mhub-pv-change';
export const M_HUB_PAGE_VIEW_CONFIRM_ACTIVATION = 'mhub-pv-confirm-activation';
export const M_HUB_PAGE_VIEW_CONFIRM_DEACTIVATION = 'mhub-pv-confirm-deactivation';
export const M_HUB_PAGE_VIEW_CONFIRM_CHANGE = 'mhub-pv-confirm-change';
export const M_HUB_ACTION_ADD = 'mhub-act-add';
export const M_HUB_ACTION_DEACTIVATE = 'mhub-act-deactivate';
export const M_HUB_ACTION_CHANGE = 'mhub-act-change';

export const DATA_MERGE_VARIANTS = [
  { productId: '10139481', memberSlots: 2, groupFee: 2.05, bonusData: 500 },
  { productId: '11242230', memberSlots: 3, groupFee: 3.08, bonusData: 500 },
  { productId: '11242231', memberSlots: 4, groupFee: 4.1, bonusData: 500 },
  { productId: '10139482', memberSlots: 5, groupFee: 5.13, bonusData: 1000 },
  { productId: '11242232', memberSlots: 6, groupFee: 6.15, bonusData: 1000 },
  { productId: '11242233', memberSlots: 7, groupFee: 7.17, bonusData: 1000 },
  { productId: '11242234', memberSlots: 8, groupFee: 8.2, bonusData: 1000 },
  { productId: '11242235', memberSlots: 9, groupFee: 9.23, bonusData: 1000 },
  { productId: '10145209', memberSlots: 10, groupFee: 10.25, bonusData: 2500 },
];
export const DATA_MERGE_2SN_VARIANT = DATA_MERGE_VARIANTS.find(item => item.memberSlots === 2);
export const DATA_MERGE_MEMBERSHIP_FEE = 0;
export const DATA_MERGE_NAME = 'Spojenie dát';

export const DATA_SHARING_PRODUCT_ID = '10139459';
export const DATA_SHARING_NAME = 'Zdieľam svoje dáta';
export const DATA_SHARING_MEMBER_SLOTS = 4;
export const DATA_SHARING_GROUP_FEE = 0;
export const DATA_SHARING_MEMBERSHIP_FEE = 3.08;
export const DATA_SHARING_BONUS_DATA = 0;

export const API_CHARACTERISTIC_CONTRIBUTOR = 'shsContributor';
export const API_CHARACTERISTIC_MEMBER = 'shsMember';
export const API_CHARACTERISTIC_THIRD_PARTY_NOTIFICATION_SN = 'notificationMSISDN';
export const API_CHARACTERISTIC_SN = 'MSISDN';
export const API_CHARACTERISTIC_VARIANT = 'variant';
export const API_CHARACTERISTIC_PRODUCT_SPECIFICATION_ID = 'productSpecification.id';
export const API_CHARACTERISTIC_IS_NOTIFIED = 'isNotified';
export const API_CHARACTERISTIC_IN_PROGRESS_CANCELLABLE = 'arePendingChangesCancellable';

export const API_CHARACTERISTIC_STATE_ACTIVE = 'active';
export const API_CHARACTERISTIC_STATE_TO_BE_REMOVED = 'toberemoved';
export const API_CHARACTERISTIC_STATE_TO_BE_ADDED = 'tobeadded';

export const API_STATUS_ACTIVE = 'active';
export const API_STATUS_PENDING_ACTIVATION = 'pending activation'; // represents activation, deactivation and change
export const API_STATUS_CLOSED = 'closed'; // represents second phase of deactivation

export const API_ORDER_TYPE_ADD = 'add';
export const API_ORDER_TYPE_DELETE = 'delete';
export const API_ORDER_TYPE_ADD_CHARACTERISTIC = 'addCharacteristic';
export const API_ORDER_TYPE_DELETE_CHARACTERISTIC = 'deleteCharacteristic';
